
import { Box, Typography } from "tabler-icons-react";
import { ColorPicker } from "../../../../components/uiConfig/GenericConfigComponentsNew";
import { FeatureDropDown } from "../optionalFeatures/widget/FearturesInputTypes/FeatureInputs"
import { SelectChangeEvent } from "@mui/material";
import { UiConfigImageUpload } from "../../../../components/uiConfig/UiConfigImageUpload";
interface Props{
    name:string,
    values:any,
setValues: React.Dispatch<React.SetStateAction<any>>;

}
 
export const AppNonStandardCustom=(props:Props)=>{
     const handleBackgroundType = (e: SelectChangeEvent<unknown>) => {
    const keyName = e.target.name;
    props.setValues({
      ...props.values,
      [keyName]: {
        ...props.values[keyName],
        value: e.target.value,
        isValueUpdated: true,
        domainType: "app_configuration",
      },
    });
  };
   function setBlobkey(blobKey: any) {
        props.setValues((prev: any) => {
            return {
                ...prev,
                [props?.name]: {
                    ...prev[props?.name],
                    value: blobKey
                }
            };
        });
    }
    return (
        <>
         <div  style={{fontWeight:"500",color:"black", marginBottom:"14px",fontSize:"15px"}} >
                            Select the header background Type
                   </div>      
          <FeatureDropDown
                            onChange={handleBackgroundType}
                            value={props.values?.appBarBackgroundType?.value}
                            name="appBarBackgroundType"
                            options={["solid", "gradient", "image"]}
                            selectLableId="appBarBackgroundType"
                            size="small"
                            width="400px"

                          />
                    
                            {props.values?.appBarBackgroundType?.value === 'solid' && (
                          
                                              <div style={{marginTop:"14px"}}>
                                                <div style={{marginBottom:"8px"}}>
                                                  <label htmlFor="solidAppbarColor" style={{fontWeight:"500",color:"black",fontSize:"15px"}} >
                                                    Enter the hexcode of the Background Solid Color
                                                  </label>
                                                  </div>
                                          
                                                <ColorPicker
                                                 name="solidAppBarColor"
                                                 values={props?.values}
                                                 setValues={props?.setValues}
                                                />
                                              </div>
                                            )
                                            }
                             {props.values?.appBarBackgroundType?.value === 'gradient' && (
                                               <div style={{marginTop:"14px"}}>
                                             <div style={{marginBottom:"8px"}} >
                                                  <label htmlFor="gradientAppBarColor" style={{fontWeight:"500" ,color:"black",fontSize:"15px"}} >
                                                    Enter the hexcode of the Background Gradient Color
                                                  </label>
                                                  </div>
                                         
                                                <ColorPicker
                                                name="gradientAppBarColor"
                                                 values={props?.values}
                                                 setValues={props?.setValues}
                                                />
                                              </div>
                                            )
                                            }
                                              {props.values?.appBarBackgroundType?.value === 'image' && (
                                                                <>
                                                                  <div className="theme-field">
                                                                    <label htmlFor="appbarBackgroundImage" style={{fontWeight:"500",fontSize:"15px",color:"black"}}>
                                                                      "Upload app bar background image",
                                                                    </label>
                                                                  </div>
                                                                  <div>
                                                                   
                                                                      <UiConfigImageUpload
                                                                           resolution={{
                                                                                                     height:512,
                                                                                                     width: 512
                                                                                                 }}
                                                                                                 max={true}
                                                                                            
                                                                                                 
                                                                       
                                                                        name="appbarBackgroundImage"
                                                                        defaultFile={props?.values["appbarBackgroundImage"]?.value}
                                                                                                 setDefaultFile={setBlobkey}
                                                                                                 accept={{
                                                                                                     image: ["png", "jpeg", "jpg"],
                                                                            }}
                                                                            fetchBlobKey={true}
                                                                                                 errorMessage={!props.values["appbarBackgroundImage"]?.value ? "Please upload Image" : ""}
                                                                        
                                                                        
                                                                      />
                                                                    
                                                                  
                                            
                                                                  </div>
                                                                
                                                                
                                                                 
                                                                
                                                                </>
                                            
                                                              )
                                                              }
        </>
    )
}